import UserProfileManager from "./UserProfileManager";

export default UserProfileManager;
